
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetAcquisitionStateIec as ObiRadarTargetAcquisitionStateIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-acquisition-state-iec.js';
 
 
 

 
 export const ObiRadarTargetAcquisitionStateIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-acquisition-state-iec',
   elementClass: ObiRadarTargetAcquisitionStateIecElement,
   events: {
     
   }
  });
 
 